import { reportLogQueueForPageHide } from '../report/reportLogQueueForPageHide';

let reportLogQueueForCurrentPageHide: (() => void) | undefined;

type AddPageHideQueueObservationEventListener = (shouldDeliverQueuedLogEvents?: boolean) => void;
export const addPageHideQueueObservationEventListener: AddPageHideQueueObservationEventListener = (
  shouldDeliverQueuedLogEvents = false
) => {
  if (reportLogQueueForCurrentPageHide) {
    window.removeEventListener('pagehide', reportLogQueueForCurrentPageHide);
  }

  reportLogQueueForCurrentPageHide = () => {
    reportLogQueueForPageHide(shouldDeliverQueuedLogEvents);
  };
  window.addEventListener('pagehide', reportLogQueueForCurrentPageHide);
};
